import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IStaffProfileFieldError } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});

export const useStaffProfileSaveAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const [fieldErrors, setFieldErrors] = useState<IStaffProfileFieldError[]>([]);
  const [isSaving, setIsSaving] = useState(false);

  const execute = useCallback(
    async (body: Record<string, unknown>) => {
      setIsSaving(true);
      setFieldErrors([]);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios.post(CONFIGURATION_APIS.STAFF_PROFILE_SAVE.baseURL, body, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        });
        toast.success(response.data?.message || "Staff saved successfully");
        return true;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError<{ message?: string; data?: { errors?: IStaffProfileFieldError[] } }>;
          setFieldErrors(axiosError.response?.data?.data?.errors ?? []);
          toast.error(axiosError.response?.data?.message || "Could not save staff");
          captureError(axiosError);
          if (axiosError.config) {
            sendCurl(axiosError.config["curlCommand"]);
          }
        }
        return false;
      } finally {
        setIsSaving(false);
      }
    },
    [configuration],
  );

  return { execute, fieldErrors, isSaving };
};
